<template>
  <div id="other-author-notice"
       class="flex-center">
    <div class="ipub-block ipub-shadow">
      <div class="ipub-h3 mar-b-20 tips flex">
        <ipub-icon style="font-size:30px"
                   class="key-color"
                   type="iconDetails" />
        <font class="mar-l-12">The invitation for review has expired</font>
      </div>
      <div class="ipub-p2">This action is not currently available. You may have already affirmed or declined your review status, or we cancelled our request for you to review the manuscript.</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
